module.exports = __webpack_public_path__ + "static/media/dsg.887b64ea.svg";